import { render, staticRenderFns } from "./TestElementsForm.vue?vue&type=template&id=0431f602&scoped=true&"
import script from "./TestElementsForm.vue?vue&type=script&lang=js&"
export * from "./TestElementsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0431f602",
  null
  
)

export default component.exports